/* tslint:disable */
/* eslint-disable */
/**
 * lq.api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PopulationLEData,
    PopulationLEDataFromJSON,
    PopulationLEDataFromJSONTyped,
    PopulationLEDataToJSON,
} from './';

/**
 * 
 * @export
 * @interface MyLQResults
 */
export interface MyLQResults {
    /**
     * 
     * @type {number}
     * @memberof MyLQResults
     */
    age?: number;
    /**
     * 
     * @type {number}
     * @memberof MyLQResults
     */
    bmi?: number;
    /**
     * 
     * @type {number}
     * @memberof MyLQResults
     */
    bmiFactor?: number;
    /**
     * 
     * @type {number}
     * @memberof MyLQResults
     */
    hpFactor?: number;
    /**
     * 
     * @type {string}
     * @memberof MyLQResults
     */
    riskClass?: string | null;
    /**
     * 
     * @type {PopulationLEData}
     * @memberof MyLQResults
     */
    populationData?: PopulationLEData;
    /**
     * 
     * @type {number}
     * @memberof MyLQResults
     */
    lifeExpectancy?: number;
    /**
     * 
     * @type {number}
     * @memberof MyLQResults
     */
    myLqRank?: number;
    /**
     * 
     * @type {number}
     * @memberof MyLQResults
     */
    myRankGap?: number;
    /**
     * 
     * @type {boolean}
     * @memberof MyLQResults
     */
    nohit?: boolean;
}

export function MyLQResultsFromJSON(json: any): MyLQResults {
    return MyLQResultsFromJSONTyped(json, false);
}

export function MyLQResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): MyLQResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'age': !exists(json, 'age') ? undefined : json['age'],
        'bmi': !exists(json, 'bmi') ? undefined : json['bmi'],
        'bmiFactor': !exists(json, 'bmi_factor') ? undefined : json['bmi_factor'],
        'hpFactor': !exists(json, 'hp_factor') ? undefined : json['hp_factor'],
        'riskClass': !exists(json, 'risk_class') ? undefined : json['risk_class'],
        'populationData': !exists(json, 'population_data') ? undefined : PopulationLEDataFromJSON(json['population_data']),
        'lifeExpectancy': !exists(json, 'life_expectancy') ? undefined : json['life_expectancy'],
        'myLqRank': !exists(json, 'my_lq_rank') ? undefined : json['my_lq_rank'],
        'myRankGap': !exists(json, 'my_rank_gap') ? undefined : json['my_rank_gap'],
        'nohit': !exists(json, 'nohit') ? undefined : json['nohit'],
    };
}

export function MyLQResultsToJSON(value?: MyLQResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'age': value.age,
        'bmi': value.bmi,
        'bmi_factor': value.bmiFactor,
        'hp_factor': value.hpFactor,
        'risk_class': value.riskClass,
        'population_data': PopulationLEDataToJSON(value.populationData),
        'life_expectancy': value.lifeExpectancy,
        'my_lq_rank': value.myLqRank,
        'my_rank_gap': value.myRankGap,
        'nohit': value.nohit,
    };
}


